export interface Partner {
  name: string;
  src: string;
}

export const partners: Partner[] = [
  { name: "Leier", src: "/partners/Leier.png" },
  { name: "Porotherm", src: "/partners/Porotherm.jpeg" },
  { name: "Rehau", src: "/partners/Rehau.png" },
  { name: "Rigips", src: "/partners/Rigips.png" },
  { name: "Terran", src: "/partners/Terran.png" },
  { name: "Thermodam", src: "/partners/Thermodam.png" },
  { name: "Fakro", src: "/partners/Fakro.png" },
];
